// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-modal-xl{
    width: 900px;
}

.flex-gap {
    gap: 15px;
}

.custom-padding {
    padding: 1rem 0 0 0 !important;
}

.row-show {
    display: block !important;
}
.row-hide {
    display: none !important;
}


.modal-title{ 
    margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./resources/components/public/utils/custom.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,mBAAmB;AACvB","sourcesContent":[".container-modal-xl{\n    width: 900px;\n}\n\n.flex-gap {\n    gap: 15px;\n}\n\n.custom-padding {\n    padding: 1rem 0 0 0 !important;\n}\n\n.row-show {\n    display: block !important;\n}\n.row-hide {\n    display: none !important;\n}\n\n\n.modal-title{ \n    margin-bottom: 40px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
